<div class="dialog-container">
    <div class="dialog-header">
        <div class="header-icon">
            <mat-icon>local_shipping</mat-icon>
        </div>
        <div class="header-content">
            <h2 class="dialog-title">All Trucks Assigned</h2>
            <p class="dialog-subtitle">
                Booking <strong>{{ data.order.ref }}</strong> already has all trucks assigned.
                What would you like to do?
            </p>
        </div>
    </div>

    <div class="dialog-body">
        <button class="action-card" (click)="select('resubmit')">
            <div class="action-icon resubmit-icon">
                <mat-icon>replay</mat-icon>
            </div>
            <div class="action-text">
                <span class="action-title">Re-Submit</span>
                <span class="action-desc">Re-submit the current truck assignment to the system</span>
            </div>
            <mat-icon class="action-arrow">chevron_right</mat-icon>
        </button>

        <button class="action-card" (click)="select('update')">
            <div class="action-icon update-icon">
                <mat-icon>edit</mat-icon>
            </div>
            <div class="action-text">
                <span class="action-title">Update Truck</span>
                <span class="action-desc">View and modify the assigned truck list</span>
            </div>
            <mat-icon class="action-arrow">chevron_right</mat-icon>
        </button>
    </div>

    <div class="dialog-actions">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
    </div>
</div>
